import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconShoppingBag$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconShoppingBag extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '86f255676c9b97b8189cdb2280adb86c7393d4a6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fca1bb09b1836f37a56269b613ed05941516bcd0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bdf81e82c8bf744322457e0e2598b282b8f5c820', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.828 10.134a1.25 1.25 0 0 0-1.25-1.136h-1.33l.002-2.746a3.255 3.255 0 0 0-3.932-3.182A3.31 3.31 0 0 0 7.75 6.345l-.002 2.653h-1.33a1.247 1.247 0 0 0-1.248 1.125l-.915 8.514A1.25 1.25 0 0 0 5.504 20h10.992a1.253 1.253 0 0 0 1.248-1.377zM9.25 6.25a1.753 1.753 0 0 1 2.046-1.727 1.82 1.82 0 0 1 1.454 1.826L12.748 9h-3.5zM5.778 18.5l.861-8h1.11l.001.996a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5l-.002-.997h3.5l.002.997a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5l-.002-.997h1.11l.864 8z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-shopping-bag", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-shopping-bag"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-shopping-bag":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconShoppingBag$1);
            }
            break;
    } });
}

const CosmosIconShoppingBag = CosmosIconShoppingBag$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconShoppingBag, defineCustomElement };
